var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.238985 10.556C-0.0734518 10.8684 -0.0883298 11.4263 0.246424 11.7536C0.573739 12.0809 1.13166 12.0734 1.4441 11.761L5.99675 7.2013L10.5568 11.761C10.8767 12.0809 11.4272 12.0809 11.7545 11.7536C12.0744 11.4189 12.0818 10.8759 11.7545 10.556L7.20186 5.99628L11.7545 1.44399C12.0818 1.12413 12.0818 0.573694 11.7545 0.246405C11.4198 -0.0734461 10.8767 -0.0808845 10.5568 0.238966L5.99675 4.7987L1.4441 0.238966C1.13166 -0.0734461 0.5663 -0.0883229 0.246424 0.246405C-0.0808908 0.573694 -0.0734518 1.13157 0.238985 1.44399L4.79907 5.99628L0.238985 10.556Z",
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close_red.6f5a1a83.svg";
export { ForwardRef as ReactComponent };